// extracted by mini-css-extract-plugin
export default {"container":"cba-z","productName":"dba-z","price":"eba-z","dimensions":"fba-z"};